import { render, staticRenderFns } from "./subsList.vue?vue&type=template&id=58563521&scoped=true"
import script from "./subsList.vue?vue&type=script&lang=js"
export * from "./subsList.vue?vue&type=script&lang=js"
import style0 from "./subsList.vue?vue&type=style&index=0&id=58563521&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58563521",
  null
  
)

export default component.exports